export default __webpack_public_path__ + "static/media/icon-folder-remove.69a80e14.svg";